import * as CursorSpinner from '../src/components/CursorSpinner';
import {eshopUserToolsRefresh} from './eshopUserToolsRefresh';
import $ from 'jquery';

export default (props, e) => {
	e.preventDefault();
	CursorSpinner.pushToQueue('addItemsToBasket');
	$.post(e.target.getAttribute('href'), function(data) {
		CursorSpinner.removeFromQueue('addItemsToBasket');
		edeeshopPopup.createPopup($(data).find('#pageContainer'), 'esp__target--add-to-cart esp-add-to-cart');
		eshopUserToolsRefresh();
	});
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/eshopOrderClick.js